import workspace from "../core/workspace";

/**
 * Helper for mobile drag and drop functionality
 */
export const mobileDragHelper = {
  /**
   * Check if drop position is over canvas
   */
  isDropOnCanvas(x, y) {
    const element = document.elementFromPoint(x, y);
    console.log('Element at drop point:', element);

    const canvas = workspace.getCanvas();
    console.log('Canvas element:', canvas);

    const isOnCanvas = element && (element === canvas || element.closest('canvas'));
    console.log('Is on canvas:', isOnCanvas);

    return isOnCanvas;
  },

  /**
   * Get canvas coordinates from screen coordinates
   */
  getCanvasCoordinates(x, y) {
    const canvas = workspace.getCanvas();
    const canvasRect = canvas.getBoundingClientRect();
    return {
      x: x - canvasRect.left,
      y: y - canvasRect.top
    };
  },

  /**
   * Dispatch custom drop event to canvas
   */
  dispatchCanvasDrop(data) {
    const canvas = workspace.getCanvas();
    const customDropEvent = new CustomEvent('mobileDrop', {
      detail: data
    });
    canvas.dispatchEvent(customDropEvent);
  },

  /**
   * Handle drop on canvas
   */
  handleCanvasDrop(dropInfo, additionalData = {}) {
    const { x, y } = dropInfo;

    console.log('handleCanvasDrop - checking if drop on canvas:', x, y);

    if (!this.isDropOnCanvas(x, y)) {
      console.log('Drop not on canvas');
      return false;
    }

    const canvasCoords = this.getCanvasCoordinates(x, y);
    console.log('Canvas coordinates:', canvasCoords);

    this.dispatchCanvasDrop({
      x: canvasCoords.x,
      y: canvasCoords.y,
      ...dropInfo.data,
      ...additionalData
    });

    return true;
  },

  /**
   * Create standard drag data for features
   */
  createFeatureDragData(feature, parentFeature, partId, additionalData = {}) {
    return {
      featureId: feature.dbFeature.id,
      parentFeatureId: parentFeature ? parentFeature.dbFeature.id : null,
      partId: partId,
      ...additionalData
    };
  }
};

